import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { userLogout, supportLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";
import type { SharedProps } from "./shared";

// Not exported — matches the apps.
interface Props extends SharedProps {}

const initialState: Props = {
  ...sharedInitialState,
}

export const RequestHeaderSlice = createSlice({
  // ⚠️ Typo preserved deliberately — see ./shared.
  name: "reuqestHeaderData",
  initialState,
  reducers: {
    ...sharedReducers,
    // Web-only.
    updateRequestHeaderSlice: (state, action) => {
      return action.payload;
    }
  },
  // Web-only, and these have REAL bodies: both clear the stored header data.
  extraReducers: (builder) => {
    builder
      .addCase(userLogout, (state) => {
        state.data = {}
      })
      .addCase(supportLogout, (state) => {
        state.data = {}
      });
  },
});

export const {
  saveRequestHeaderData,
  resetRequestHeaderData,
  updateRequestHeaderSlice
} = RequestHeaderSlice.actions;

export default RequestHeaderSlice.reducer;
